/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/12 2:11 下午
*/
import request from '@/utils/request'

// 获取首页统计数据
export function getIndexTotal() {
    return request({
        url: '/agent/proxy-user/fAgent/index',
        method: 'get',
    })
}

// 获取首页网点列表
export function getStoreList(params) {
    return request({
        url: '/agent/proxy-user/fAgent/index/storeList',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/home.js